import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
import { CookieService } from 'ngx-cookie-service';

declare var jQuery: any;

@Component({
	selector: 'app-videos',
	templateUrl: './videos.component.html',
	styleUrls: ['./videos.component.css']
})
export class VideosComponent implements OnInit {

	surveyCommentList: any;
	pager: any = {};
	pagedItems: any[];
	UservideoList: any[];
	total: any;
	limit: any;
	pageNo: any;
	base64textString: any;
	attached_image: any;
	flashMsg: string;
	selectedSurveyData: any;
	selectedSurveyId: any;
	surveyTypeList: any;
	surveyExpiryList: any;
	surveyCategoryList: any;
	url: any;
	surveyType: any;
	isDeleteSurvey: boolean;
	deleteSelectedSurveyData: any;
	searchStr: any = "";
	surveyCategory: any = "";
	surveyStatus: any = "";
	isSurveyAvailable: boolean = false;
	redirectUrl: any;
	activePageNo: number = 0;
	survey_question: any;
	survey_comment: any;

	constructor(
		private commonService: CommonService,
		private authServicess: AuthService,
		private pagerService: PagerService,
	) { }

	ngOnInit() {
		this.initialiseSurvey();
		this.commonService.process();
	}

	// Get Survey List
	initialiseSurvey = function () {

		this.commonService.setTitle();
		this.limit = 10;
		this.pageNo = 1;
		this.url = '';
		this.surveyStatus = 0;
		$(".navbar-brand").text("Videos");

		// Get survey list
		this.getSurveyList(this.pageNo, this.limit);

	
	}
	@ViewChild('videoPlayer') videoplayer: ElementRef;

	toggleVideo(event: any) {
		this.videoplayer.nativeElement.play();
	}

	// Get vidoe list
	getSurveyList = function (pageNo, limit,Params="") {

		this.commonService.process();
		this.authServicess.getVideQuestionreportList(pageNo, limit,Params).subscribe(data => {
			
			if (data.success) {
				this.isSurveyAvailable = false;

				this.surveyCommentList = data.result;
				this.total = data.result.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			} else {
				this.surveyCommentList = [];
				this.isSurveyAvailable = true;
			}

			this.commonService.hideProcess();
		},(error)=>{
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		//$('.pages').removeClass('active')
		$('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		// this.pagedItems = this.surveyCommentList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getSurveyList(page, this.limit);
		}
	}

	// Update survey status .
	updateViolationVideo = function (data,action) {
         console.log(data)
		 console.log(action)
		var x = confirm('Are you sure want to '+action+' video?');
		if (!x) {
			return false;
		}
		
		
		if(data.videoData.postuser_id.email==null || data.videoData.postuser_id.email==undefined){
			return;
		}

		var videoId = data.videoid;
		var ReportId = data._id;
		var email = data.videoData.postuser_id.email;
        console.log(data)

		this.authServicess.updateViolationVideo(videoId,data.section_type).subscribe(data => {
			if (data.success) {
				jQuery.growl.notice({ title: 'Success', message: data.message });
				this.getSurveyList(this.pageNo, this.limit);
			} else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	deleteVideo= function (data) {
	   var x = confirm('Are you sure want to delete video?');
	   if (!x) {
		   return false;
	   }
	   
	   
	   if(data.videoData.postuser_id.email==null || data.videoData.postuser_id.email==undefined){
		   return;
	   }
	   var ReportId = data._id;
	   var email = data.videoData.postuser_id.email;
	
	   this.authServicess.deleteVideoReport(ReportId).subscribe(data => {
		   if (data.success) {
			   jQuery.growl.notice({ title: 'Success', message: data.message });
			   this.getSurveyList(this.pageNo, this.limit);
		   } else {
			   jQuery.growl.error({ title: 'Error', message: data.error });
		   }
	   });
	}



	PlaySelectedUservideo = function (video) {

       console.log(video)
	   this.UservideoList = [video.video];
		// if(video.videoid==null || video.videoid==undefined){
		// 	this.UservideoList = [this.commonService.videoUrl+'video.mp4'];
		// 	return;
		// }

		// var res = video.videoid.video.substring(0, 4);

		// if (res.toLocaleUpperCase() == 'HTTP') {
		// 	this.UservideoList = [video.videoid.video];
		// } else {
		// 	this.UservideoList = [this.commonService.videoUrl + video.videoid.video];
		// }

		// console.log(this.UservideoList);
	}


	searchSurveyReportActivity = function(){
		var fromdate =  $('#fromdate').val();
		var todate =  $('#todate').val();
		var surveyCategory =  $('#surveyCategory').val();
		var surveyType =  $('#surveyType').val();
		var param = `fromdate=`+fromdate+`&todate=`+todate+`&surveyCategory=`+surveyCategory+`&surveyType=`+surveyType;
		this.getSurveyList(1,this.limit,param)
	}

}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/videos/videos.component.ts